<template>
  <div class="mx-auto px-4 pb-12 sm:px-4 lg:px-8">
    <loading v-if="isLoading" />
    <view-stock-modal
      :stock-id="dataStock.id"
      with-ordered
      :columns="[
        'product_code',
        'product_name',
        'stock_qty',
        'expired_qty',
        'damaged_qty',
        'suitable_for_sale_qty',
        'unsuitable_for_sale_qty',
        'reimburse_qty',
        'free_qty',
        'order_status',
        'pre_order_status',
        'weight',
        'qrcode',
        filter.warehouse.code !== 'PUSAT' ? 'is_published' : ''
      ]"
      :visible="openDetail"
      @close="openDetail = false"
    />
    <StockSummaryWidget :warehouse-id="filter.warehouse.id" watch-warehouse />
    <hr class="mt-5" />
    <div class="mb-5 rounded-lg">
      <div class="mt-4 flex flex-col">
        <div class="flex items-center justify-end space-x-2">
          <SearchWarehouseInput :inset="false" :warehouse-type="null" modal-type="office" v-model="filter.warehouse" @change="onChangeWarehouse" />
          <base-search v-model="search" @input="debounceSearch" />
          <export-dropdown />
        </div>
        <div class="my-2 flex sm:-mx-6 lg:-mx-8">
          <div
            class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
          >
            <StockTable
              with-area-zero-price
              with-global-stock
              @detail="detailStock"
              @page-changed="onPageChangeProducts"
            />
          </div>
        </div>
        <warehouse-modal
          :visible="openListWarehouse"
          @close="() => (openListWarehouse = false)"
          @search="debounceSearchWarehouse"
          @page-change="onPageChangeWarehouse"
          @change="changeWarehouse"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'debounce';
import { stockColumns } from '@/services/columns.service';
import StockTable from '@/components/stock/stock-table.vue';
import WarehouseModal from '@/components/modal/warehouse-modal.vue';
import BaseSearch from '@/components/base/Search.vue';
import StockSummaryWidget from '@/components/stock/stock-summary-widget.vue';
import ExportDropdown from '@/components/stock/export-stock-dropdown.vue';
import ViewStockModal from '@/components/stock/view-stock-modal.vue';
import SearchWarehouseInput from '../../../../components/warehouse/search-warehouse-input.vue';

export default {
  name: 'Stocks',
  components: {
    // Modal,
    StockTable,
    WarehouseModal,
    BaseSearch,
    StockSummaryWidget,
    ExportDropdown,
    ViewStockModal,
    SearchWarehouseInput
  },
  data() {
    return {
      stockColumns,
      search: null,
      searchWarehouse: '',
      openDetail: false,
      openListWarehouse: false,
      dropdown: false,
      dataStock: {},
      filter: {
        gudang: {
          id: '',
          code: '',
          name: '',
        },
        warehouse: {
          id: null,
          code: null,
          name: null,
          searchCode: null,
          originalCode: null,
          area: {
            id: null,
            code: null
          }
        }
      },
      currentSelectedStock: null,
      loadStockTrxParams: {
        pageNumber: 1,
      },
      modal: 'new',
    };
  },
  computed: {
    ...mapGetters({
      getPeriod: 'periods/getPeriod',
      getStocksLoading: 'stocks/getLoading',
      getStockTrxesLoading: 'stock_trxes/getLoading',
      getPeriodsLoading: 'periods/getLoading',
      getLoadingTotalStockAvailable: 'stocks/getLoadingTotalStockAvailable',
      me: 'auth/getUser',
    }),
    isLoading() {
      return (
        this.getStockTrxesLoading ||
        this.getStocksLoading ||
        this.getPeriodsLoading ||
        this.getLoadingTotalStockAvailable
      );
    },
    filteredData() {
      return this.getResults.filter((products) =>
        products.attributes.name
          .toLowerCase()
          .includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions({
      fetchStocksByWarehouse: 'stocks/fetchStocksByWarehouse',
      fetchWarehouses: 'warehouses/fetchWarehouses',
      fetchWarehouseById: 'warehouses/fetchWarehouseById',
      fetchWarehouseStock: 'warehouses/fetchWarehouseStock',
      fetchStockById: 'stocks/fetchStockById',
      fetchStockTrxesByStock: 'stock_trxes/fetchStockTrxesByStock',
      fetchCurrentPeriod: 'periods/fetchCurrentPeriod',
    }),
    openModal() {
      this.openListWarehouse = !this.openListWarehouse;
      this.fetchWarehouses({
        pageNumber: 1,
        pageSize: 5,
      });
    },
    getProductCategory(id) {
      let category = this.getProducts.included.filter(function (el) {
        return el.id === id;
      });
      return category[0].attributes.name;
    },
    async loadStockTrx({ periodUuid } = { periodUuid: null }) {
      let currentPeriod;

      if (!periodUuid && !this.getPeriod.data.id) {
        currentPeriod = await this.fetchCurrentPeriod();
      } else {
        currentPeriod = {
          data: this.getPeriod,
        };
      }

      await this.fetchStockTrxesByStock({
        stockId: this.currentSelectedStock.id,
        params: {
          params: {
            'page[size]': 5,
            'page[number]': this.loadStockTrxParams.pageNumber,
            sort: 'latest',
            'filter[period_uuid]': periodUuid ?? currentPeriod.data.data.id,
          },
        },
      });
    },
    onChangePeriod(periodUuid) {
      this.loadStockTrx({ periodUuid });
    },
    onPageChangeProducts(page) {
      this.loadStocks({
        warehouse_id: this.filter.warehouse.id,
        pageNumber: page,
        pageSize: 5,
        search: this.search,
      });
    },
    onPageChangeWarehouse(page) {
      this.fetchWarehouses({
        pageNumber: page,
        pageSize: 5,
        search: this.searchWarehouse,
      });
    },
    onChangePageStockTrx(page) {
      this.loadStockTrxParams.pageNumber = page;

      this.loadStockTrx();
    },
    onChangeWarehouse() {
      this.loadStocks({
        warehouse_id: this.filter.warehouse.id,
        pageNumber: 1,
        pageSize: 5,
        search: this.search,
      });
    },
    debounceSearch: debounce(function () {
      this.loadStocks({
        warehouse_id: this.filter.warehouse.id,
        pageNumber: 1,
        pageSize: 5,
        search: this.search,
      });
    }, 300),
    debounceSearchWarehouse: debounce(function (q) {
      this.searchWarehouse = q;
      this.fetchWarehouses({
        pageNumber: 1,
        pageSize: 5,
        search: this.searchWarehouse,
      });
    }, 300),
    async detailStock(stock) {
      this.dataStock = stock;
      this.openDetail = !this.openDetail;
    },
    changeWarehouse(data) {
      this.filter.gudang.id = data.id;
      this.filter.gudang.code = data.attributes.code;
      this.filter.gudang.name = data.attributes.name;
      this.loadStocks({
        warehouse_id: this.filter.warehouse.id,
        pageNumber: 1,
        pageSize: 5,
      });
      this.openListWarehouse = !this.openListWarehouse;
      this.searchWarehouse = '';
    },
    loadStocks(params) {
      this.fetchStocksByWarehouse({
        ...params,
        include: 'product.product-prices',
        'fields[stocks]':
          'product_code,product_name,stock_qty,stock_ordered,stock_real,product,is_orderable,free_qty,free_ordered,free_real,is_point,global_stock',
        sortName: 'updatedAt',
        sortDirection: 'desc',
      });
    },
  },
  created() {
    this.fetchWarehouseById({
      id: this.me.current_warehouse,
      params: {
        include: 'area'
      }
    }).then((response) => {
      if (response) {
        this.filter.gudang.id = response.data.data.id;
        this.filter.gudang.code = response.data.data.attributes.code;
        this.filter.gudang.name = response.data.data.attributes.name;
        
        this.filter.warehouse.id = response.data.data.id
        this.filter.warehouse.code = response.data.data.attributes.code
        this.filter.warehouse.name = response.data.data.attributes.name
        this.filter.warehouse.searchCode = response.data.data.attributes.code
        this.filter.warehouse.originalCode = response.data.data.attributes.code

        const area = this.getSingleIncluded(response.data, response.data.data.relationships.area.data.id)
        this.filter.warehouse.area.id = area.id
        this.filter.warehouse.area.code = area.attributes.code

        this.loadStocks({
          warehouse_id: this.filter.warehouse.id,
          pageNumber: 1,
          pageSize: 5,
        });
      }
    });
  },
};
</script>
